import {
  EntryStatus,
  VehicleCurrentStatus,
} from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formatUTCDate } from "utils/utils";

export const DATA = [
  {
    id: "#1",
    carNumber: "ABC 1234",
    store: "Al Ared, Riyadh",
    package: "Unlimited Shine",
    dateTime: "2025-12-31T12:39:58.083Z",
    entryType: 1, // ANPR | Manual
    status: 1,
  },
  {
    id: "#2",
    carNumber: "KSA 5678",
    store: "Al Ared, Riyadh",
    package: "Unlimited Protect",
    dateTime: "2025-12-27T12:19:58.083Z",
    entryType: 1,
    status: 2,
  },
  {
    id: "#3",
    carNumber: "RDX 9087",
    store: "Al Ared, Riyadh",
    package: "Unlimited Works",
    dateTime: "2025-12-29T12:29:58.083Z",
    entryType: 2,
    status: 3,
  },
  {
    id: "#4",
    carNumber: "JED 3456",
    store: "Al Ared, Riyadh",
    package: "One Time Protect",
    dateTime: "2025-12-31T12:39:58.083Z",
    entryType: 1,
    status: 4,
  },
  {
    id: "#5",
    carNumber: "DAM 7788",
    store: "Al Ared, Riyadh",
    package: "Unlimited Shine",
    dateTime: "2025-12-31T12:39:58.083Z",
    entryType: 2,
    status: 2,
  },
];

const RecentActivity = () => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        header: t("Name"),
        key: "carNumber",
        render: (value) => value,
      },
      {
        header: t("Store"),
        key: "store",
        render: (value) => value,
      },
      {
        header: t("Date & Time"),
        key: "dateTime",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
      {
        header: t("Car Number"),
        key: "carNumber",
      },
      {
        header: t("Remark"),
        key: "Remark",
        render: (value) => (
          <div className="">
            Lorem ipsum dolor sit amet, adipiscing elit. quam...
          </div>
        ),
      },

      {
        header: t("Status"),
        key: "status",
        render: (value) => <VehicleCurrentStatus status={value} t={t} />,
      },
    ],
    [t]
  );

  return (
    <div className="recent_activity">
      <h2 className="fs_20 mb-3">{t("Recent Activities")}</h2>
      <DataTable columns={columns} data={DATA} t={t} className="" />
    </div>
  );
};

export default RecentActivity;
